<template>
  <div>
    
    <div style="text-align: center; margin-top: 40px;">
      <h3>Pré-matrícula 2026</h3>  
      <p>
        O agendamento para matrícula na rede municipal de educação está encerrado. <br>
        Mariores informações por meio do whatsapp 7732293378 ou em qualquer escola da rede municipal de ensino.
      </p>
      <!-- <p>
        O agendamento online para a terceira fase da matrícula (alunos novos na rede municipal de ensino), 
        estará disponível <br> a partir das 08:00h do dia 21/01/2026 e se encerrará às 23:59h do dia 23/01/2026.<br>        
      </p> -->
    </div>
    <div class="opcoes-menu">   

      <router-link to="lista-espera">
        <div class="op-menu">
          <img src="/public/icon/list.png" />
          <span>Consulte a Lista de Espera</span>
        </div>
      </router-link>

      <!-- <router-link to="inscricao">
        <div class="op-menu nova-inscricao">
          <img src="/public/icon/calendario.png" />
          <span> Faça sua Inscrição </span>
        </div>
      </router-link> -->
            
      <router-link to="cancela-inscricao">
        <div class="op-menu">
          <img src="/public/icon/cancelar.png" />
          <span>Cancelar Inscrição</span>
        </div>
      </router-link>

      <router-link to="consulta-inscricao">
        <div class="op-menu">
          <img src="/public/icon/consultar.png" />
          <span>Consulte sua Inscrição</span>
        </div>
      </router-link>
    
      <router-link to="calendario">
        <div class="op-menu">
          <img src="/public/icon/calendario.png" />
          <span>Calendário de Matrícula</span>
        </div>
      </router-link>
    
      <router-link to="contato">
        <div class="op-menu">
          <img src="/public/icon/contato.png" />
          <span>Contato</span>
        </div>
      </router-link>
      
      <router-link to="faq">
        <div class="op-menu">
          <img src="/public/icon/faq1.png" />
          <span>Perguntas Frequentes</span>
        </div>
      </router-link>
    
    </div>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      text: "",
    };
  },
  mounted() {
    setInterval(() => {
      window.location.reload()
    }, 30000)
  },
  methods: {
    getAmbiente() { },
  },
  components: {},
};
</script>
